import Hero from "./Hero"
import Features from "./Features"
import Footer from "../Utility/Footer"

function LandingPage() {
    return (
      <div className="">
        <Hero />
        <Features />
        <Footer />
      </div>
    );
  }
  
export default LandingPage;